import { Layout, Spin } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { get, put } from '../../Common/api'
import consumer from '../../Common/cable'
import EventPanel from './EventPanel'
import { useParams } from 'react-router'
import EventFilter from './EventFilter'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import EventDetail from './EventDetail'
import { useForm } from 'antd/es/form/Form'
import EventListXS from './EventListXS'
import EventListXL from './EventListXL'
import GlobalContext from '../GlobalContext'

export default function EventsPage () {
  const [events, setEvents] = useState([])
  const [event, setEvent] = useState({})
  const [pagination, setPagination] = useState({})
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState({})
  const { id } = useParams()
  const [form] = useForm()
  const [inCharge, setInCharge] = useState()
  const { notificationApi } = useContext(GlobalContext)

  const screens = useBreakpoint()

  useEffect(() => {
    componentDidMount()
    getInCharge()
    if (id) { showEvent(id) }
  }, [])

  useEffect(() => {
    updateEvents(event)
  }, [event])

  const getInCharge = async () => {
    await get({
      url: 'admin/events/in_charge_options',
      params: {},
      onSuccess: (res) => {
        setInCharge(res)
      }
    })
  }

  const updateEvents = (updatedEvent) => {
    if (updatedEvent?.id) {
      if (events.find((e) => e.id === updatedEvent.id)) {
        setEvents(events.map((e) => (e.id === updatedEvent.id) ? { ...e, ...updatedEvent } : e))
        if (selectedEvent.id === updatedEvent.id) {
          setSelectedEvent({ ...selectedEvent, ...updatedEvent })
        }
      } else {
        setEvents([{ ...updatedEvent, new: true }, ...events])
      }
    }
  }

  const componentDidMount = () => {
    consumer.subscriptions.create({ channel: 'EventsChannel' }, {
      connected: () => { console.log('connected') },
      disconnected: () => { },
      received: (data) => { setEvent({ ...data.event, content: data.content_trix_html }) }
    })
  }

  const getEvents = async (eventFilter, pageNumber) => {
    setLoading(true)
    await get({
      url: 'admin/events',
      params: { ...eventFilter, page: pageNumber || 1 },
      onSuccess: (res) => {
        setLoading(false)
        setEvents(res.events)
        setPagination(res.pagination)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const updateEvent = async (event) => {
    setLoading(true)
    await put({
      url: `admin/events/${event.id}`,
      params: event,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (newEvent) => {
        setSelectedEvent({ ...newEvent.event, content: newEvent.content_trix_html, comments: event.comments })
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getComments = async (id) => {
    setLoading(true)
    await get({
      url: `admin/events/${id}`,
      params: {},
      onSuccess: (res) => {
        setLoading(false)
        setSelectedEvent({ ...res.event, comments: res.comments, content: res.event.content_trix_html })
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const showEvent = (id) => {
    getComments(id)
    setOpen(true)
  }

  const resolveEvent = async (event) => {
    setLoading(true)
    await put({
      url: `admin/events/${event.id}`,
      params: { ...event, resolved: !event.resolved },
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (res) => {
        setLoading(false)
        event = { ...res.event, content: res.event.content_trix_html }
        updateEvents(event)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onClose = () => {
    setSelectedEvent({})
    setOpen(false)
  }

  const addComment = (comments) => (comment) => {
    setSelectedEvent({
      ...selectedEvent,
      comment_count: selectedEvent.comment_count + 1,
      comments: [...comments, comment]
    })
  }

  return (
    <Layout>
      <Spin spinning={loading}>
        {!screens.xs &&
          <>
            <EventFilter setLoading={setLoading} getEvents={getEvents} form={form} inCharge={inCharge} />
            <EventListXL events={events} showEvent={showEvent} pagination={pagination} getEvents={getEvents} filters={form.getFieldsValue()} resolveEvent={resolveEvent} updateEvents={updateEvents} inCharge={inCharge} />
            <EventPanel event={selectedEvent} open={open} onClose={onClose} updateEvent={updateEvent} updateEvents={updateEvents} setSelectedEvent={setSelectedEvent} addComment={addComment} inCharge={inCharge} />
          </>
        }
        {screens.xs && !id && <EventListXS events={events} showEvent={showEvent} mobile={true} pagination={pagination} updateEvents={updateEvents} inCharge={inCharge} />}
        {screens.xs && id && <EventDetail event={selectedEvent} updateEvent={updateEvent} updateEvents={updateEvents} showEvent={() => showEvent(id)} addComment={addComment} inCharge={inCharge} />}
      </Spin>
    </Layout>
  )
}
